import React from "react";
import { AutocompleteField, FormItem } from "@tiny/components";

interface ISPArrayValueProps {
  prefixName: string;
  disabled?: boolean;
}

const ISP_ARRAY_LIST = [
  "Microsoft",
  "Google",
  "Yahoo",
  "Apple",
  "Education",
  "Government",
  "Military",
  "Comcast",
  "ATT",
  "Cox",
  "Other",
];

function ISPArrayValue(props: ISPArrayValueProps) {
  const { prefixName, disabled } = props;
  const name = `${prefixName}.value.value`;

  return (
    <FormItem
      name={name}
      rules={{
        required: {
          value: true,
          message: "Required field",
        },
      }}
      watchValue
    >
      <ISPArrayField disabled={disabled} />
    </FormItem>
  );
}

interface ISPArrayFieldProps {
  value?: string[];
  onChangeValue?: (value: string[]) => void;
  helperText?: string;
  error?: boolean;
  inputRef?: React.ForwardedRef<HTMLInputElement>;
  disabled?: boolean;
}

function ISPArrayField(props: ISPArrayFieldProps) {
  const { value, onChangeValue, helperText, error, inputRef, disabled } = props;
  const [internalValue, setInternalValue] = React.useState<string[]>(
    value || []
  );

  const changeValue = (v: string[]) => {
    setInternalValue(v);
    onChangeValue?.(v);
  };

  return (
    <>
      <AutocompleteField
        inputRef={inputRef}
        placeholder={!(internalValue || value) || "Select ISP"}
        multiple
        options={ISP_ARRAY_LIST}
        value={internalValue || value}
        onChangeValue={changeValue}
        getOptionLabel={(option) => option}
        limitTags={1}
        helperText={helperText}
        error={error}
        showHelperTextMargin
        disabled={disabled}
      />
    </>
  );
}

export default ISPArrayValue;
